import { MutationKey } from '@tanstack/react-query';

import { CouponType } from '/component/Economy/Coupons/types';

export const getCouponMutationKey = (type: CouponType, commonMutationKey: MutationKey) =>
  commonMutationKey.concat(type);
